// extracted by css-extract-rspack-plugin
export default {"root":"MNMU_","content":"DiDfB"};